import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { useTranslation } from 'react-i18next';
import { POST_URL } from '@utils/api/endpoints.ts';

export interface ManageGroupMembersData {
  add?: number[];
  delete?: number[];
}

export const useManageGroupMembers = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const manageGroupMembers = async ({
    customerId,
    groupId,
    data
  }: {
    customerId: number;
    groupId: number;
    data: ManageGroupMembersData;
  }): Promise<void> => {
    try {
      const response = await Axios.patch<void>(
        `${POST_URL(customerId.toString(), groupId.toString()).manageGroupMembers}`,
        data
      );
      return response.data;
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any).response) {
        throw error;
      }
      throw new Error(t('an-error-occurred-while-managing-group-members'));
    }
  };

  return useMutation<
    void,
    AxiosError<BaseError>,
    { customerId: number; groupId: number; data: ManageGroupMembersData }
  >(
    ({ customerId, groupId, data }) =>
      manageGroupMembers({ customerId, groupId, data }),
    {
      onSuccess: (_, { customerId }) => {
        queryClient.invalidateQueries(['customerGroup', customerId]);
      },
      useErrorBoundary: false
    }
  );
};
